<template>
    <div class="my-charts">
        <div :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";
import {markRaw} from "vue";
import chartResizeMixin from "./chartResizeMixin";

export default {
    name: "stDataChart",
    mixins: [chartResizeMixin],
    props: {
        id:{
            type: String,
            default:"st_data_echarts"
        },
        dataList:{
            type: Array,
            default: []
        }
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
        dataList(newValue,oldValue){
            this.chartList = newValue;
            this.init()
        }
    },
    data() {
        return {
            lineChart: null,
            chartList:[],
            maxNum:40,
            chartOption:{
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    formatter: function (params) {
                        return '教师行为: ' + + params[0].value[0] + '分钟'+
                          '<br>'+'学生行为: ' + params[0].value[1] + '分钟';
                    }
                },
                xAxis: {
                    name:'T轴(分钟)',
                    type:'value',
                    splitNumber:10,
                    max:90,
                },
                yAxis: {
                    name:'S轴(分钟)',
                    type:'value',
                    splitNumber:10,
                    max:90,
                },
                series: [
                    {
                        data: [],
                        type: 'line',
                        smooth: true,
                        symbolSize: 0,
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            this.chartList = this.dataList;
            if (!this.chartList||this.chartList.length===0){
                return
            }
            this.lineChart = markRaw(echarts.init(document.getElementById(this.id)));
            this.chartOption.series[0].data = this.chartList;
            this.lineChart.setOption(this.chartOption);
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    color: #333!important;
    display: flex;
    > div {
        width: 100%;
        max-width: 580px;
        height: 500px;
        margin: auto;
    }
    div + div {
        margin-left: 10px;
    }
}
</style>